export { default } from "./Truncate";
